export class OperatorModel {
    public cod: number;
    public username: string;
    public pswd: string;
    public active: string;
    public sysout: string;
    public authority: string;
    public email: string;
    public devicename: string;

    [x: string]: any;
}
